import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { withTranslate } from 'shared/hocs/withTranslate';
import carImage from 'shared/assets/images/articles/leasing/car.png';
import manImage from 'shared/assets/images/articles/leasing/man.png';
import passportImage from 'shared/assets/images/articles/leasing/passport.png';
import headWithKey from 'shared/assets/images/articles/leasing/head-with-key.png';
import bluredCar from 'shared/assets/images/articles/leasing/blured-car.png';
import { imageBgStyle } from 'shared/helpers/common';

import s from './LeasingConditions.css';

const items = [
  {
    image: manImage,
    text: 'Вам исполнился 21 год',
  },
  {
    image: carImage,
    text: 'Вы выбрали автомобиль',
  },
  {
    image: passportImage,
    text: 'У вас есть действительный паспорт',
  },
];
class LeasingConditions extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    t: PropTypes.func.isRequired,
  };
  static defaultProps = {
    title: 'Условия лизинга автомобиля',
  };
  renderItem = (image, text) => {
    const txt = this.props.t(text);
    return (
      <div className={s.item} key={txt}>
        <div className={s.icon}>
          <img alt={txt} src={image} width={40} height={40} />
        </div>
        <div className={s.text}>
          {txt}
        </div>
      </div>
    );
  };

  render() {
    const title = this.props.t(this.props.title);
    return (
      <div className={s.root}>
        <div className={s.bg} />
        <div className={s.title}>
          {title}
        </div>
        <div className={s.items}>
          {items.map(item => this.renderItem(item.image, item.text))}
        </div>
        <div className={s.image} style={imageBgStyle(bluredCar, 'contain')}>
          <img alt={title} src={headWithKey} width={320} height={270} />
        </div>
      </div>
    );
  }
}

export default withStyles(s)(withTranslate(LeasingConditions));



// WEBPACK FOOTER //
// ./src/shared/components/Article/Leasing/LeasingConditions/LeasingConditions.js